import { render, staticRenderFns } from "./AttendanceMergeDialog.vue?vue&type=template&id=0a21fd80&scoped=true"
import script from "./AttendanceMergeDialog.vue?vue&type=script&lang=js"
export * from "./AttendanceMergeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21fd80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
